import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import ArrowBack from '@material-ui/icons/ArrowBack';
//import PropTypes from 'prop-types';
import Print from '@material-ui/icons/Print';
import React, { useEffect, useRef, useState } from 'react';
import { CreateButton, EditButton, Show, useShowController, SimpleShowLayout,Title} from 'react-admin';
import { Link } from "react-router-dom";
import { useReactToPrint } from 'react-to-print';
import Segment from '../communs/Segment.js';
import Contact from '../dialog/Contact';
import { formatAdresse, formatDate, has_role } from '../references';
import Assignment from '@material-ui/icons/Assignment';
import EtiqPlusieurs from '../printEtiquette/EtiqPlusieurs';
import { makeStyles } from '@material-ui/core/styles';


const ShowCampagne = (props)=> {
    const [titre, setTitre] = useState();
    const [fullname, setFullanme] = useState(); 
    const { record } = useShowController(props);
    const [showEtiquette, setShowEtiquette] = useState(false);

    const useStyles = makeStyles({
        root: { width: window.width < 840 ? window.width : '840px', margin: 'auto' },
        spacer: { height: 10 },
        invoices: { margin:  "0", padding: "0" },
        color_client: { color: '#7209b7', fontWeight: 'bold', padding: 0, margin: 0 }
    });

    const classes = useStyles();

    useEffect(() => {
        setFullanme(localStorage.getItem('fullname'));
        setTitre(getPdfName(record));
    }, []);

    const getPdfName=(record)=>{
        return record ? record.code:"";
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        documentTitle:titre
    });
    const componentRef = useRef();

    const handleShowEtiquette=(isShowEtiquette)=>{
        const infos=getPdfName(record);
        var varTitre= isShowEtiquette?'Etiquette_'+infos:'Facture_'+infos;
        setShowEtiquette(isShowEtiquette);
        setTitre(varTitre);
    }
  
const   PostShowActions = ({ basePath, data, resource }) => (
    <CardActions style={cardActionStyle}>
        <Button color="primary"  onClick={handlePrint} label="Imprimer">
            <Print />
        </Button>
        {has_role(props.permissions,'ROLE_MANAGER') ?
            <>
                <CreateButton basePath={basePath} />
                <Contact titre="Contact clients" message={"Copiez les téléphones des clients de la campagne "+data.code+" ou envoyez-leurs des SMS automatiquement."} 
                    campCode={data.code} campId={data.id} campType={data.type}/>
                
            </>
            :null
        }
        {has_role(props.permissions,'ROLE_MANAGER') || 
            (has_role(props.permissions,'ROLE_AG_EXP_MARITIME_FR') && data.type!=='AERIEN_DE_CNKRY' ) ||
            (has_role(props.permissions,'ROLE_AG_EXP_AERIEN_GUI') && data.type==='AERIEN_DE_CNKRY' ) ?
                <EditButton basePath={basePath} record={data} />
            :null
        }
        <Button startIcon={<Assignment />}  color="primary" onClick={()=>handleShowEtiquette(true)}>Etiquette</Button>
        <Button component={Link} to={basePath}  color="primary" ><ArrowBack/> Retour</Button>

    </CardActions>
);

const ShowEtiquetteActions = ({ resource,basePath }) => (
    <CardActions style={cardActionStyle}>
        <Button color="primary" onClick={handlePrint}><Print />Imprimer</Button>
        <Button  label="Retour" color="primary"  onClick={()=>handleShowEtiquette(false)} ><ArrowBack />Retour</Button>
    </CardActions>
);

//className={classes.root}
//className={classes.invoices}

if(!record) return null;
    return (
        showEtiquette ?
        <>
        <Title title={'Etiquette - '+record.code} />
        <span  >
        <ShowEtiquetteActions {...props}></ShowEtiquetteActions>
        <SimpleShowLayout  className={classes.root} >
            
            <div ref={componentRef} className={classes.invoices}  >
                <EtiqPlusieurs   {...props} record={record} allCampEtiq={true}/>
            </div>
            </SimpleShowLayout> 
        </span>
        </>
    :


        <Show {...props}  actions={<PostShowActions />} title={fullname}>
               <Segment  ref={componentRef} tiket={true} datas={
                  [
                    {id:'numero',label:'Numéro',name:record.numero},
                    {id:'type',label:'Type',name:record.type},
                    {id:'status',label:'Status',name:record.status},
                     {id:'date_depart',label:'Date départ',name:record.dateDepart},
                     {id:'lieu_depart',label:'Adresse départ',name:formatAdresse(record.depart)},
                     {id:'date_arrive',label:'Date arrivé',name:record.dateArrive},
                     {id:'lieu_arrive',label:'Adresse arrivée',name:formatAdresse(record.arrive)},
                     {id:'commentaire',label:'Commentaire',name:record.commentaire},
                     {id:'lastModifiedDate',label:'Date',name:formatDate(record.lastModifiedDate)},
                  ]
                } code={record.code}/>
           </Show>
        );
}


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    flexDirection: 'column'
};

/*
const infosCampagne=(data,separateur)=>{
    const A="Bonjour Cher Client,"+separateur+
    "Vous trouverez ci-dessous les détails de la campagne dans laquelle se trouve votre colis."+separateur+
    "N'hésitez pas à nous contacter si vous avez des questions."+separateur+
    "Au plaisir de vous envoyer vos prochains colis."+separateur;

    const {type,status,dateDepart,dateArrive,lastModifiedDate,depart,arrive}=data;
    
        return A+separateur+"Type : "+ type+separateur+
        "Status : "+ status+separateur+
        "Date départ : "+ dateDepart+separateur+
        "Adresse départ : "+ formatAdresse(depart)+separateur+
        "Adresse arrivée : "+ formatAdresse(arrive)+separateur+
        "Date arrivée : "+ dateArrive+separateur+
        "Date : "+ lastModifiedDate+separateur
    
}
*/

export default ShowCampagne;
